module.exports = __webpack_public_path__ + "static/img/2.393add4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail3/2.png
// module id = J1XY
// module chunks = 19